export const defaultStyle = {
    galleryContainer: "px-[36.5px] mt-20 pt-60",
    galleryHeading: "text-[#070707] text-[28px] text-center font-black mb-20",
    filterTabs: "flex justify-center flex-wrap mb-15 mx-[-25px] text-[#724D8D]",
    filterTab: "uppercase bg-white border border-[#070707] transition ease-in-out duration-300 px-12 py-8 text-16 text-center bold leading-[22px] mx-5 mb-10 md:w-[186px] md:px-15 md:py-13 md:text-20 md:mx-10 md:my-0 hover:cursor-pointer hover:bg-[#724D8D] hover:text-white",
    activeTab: "bg-[#724D8D] text-white",
    panels: "panels",
    imgWrapper: " flex flex-wrap",
    imageBoxWrpr: "mt-25 px-5 w-full md:w-1/3 lg:w-1/4 md:px-15",
    imgContainer: "block",
    imgWrpr: "min-h-[130px] max-h-[130px] h-[100%] w-100% object-cover md:min-h-[280px] md:max-h-[280px] lg:min-h-[275px] lg:max-h-[275px]",
    panelHeading: "text-[17px]",
    contentWrapr: "flex flex-col-reverse",
    text: " text-[#070707] font-bold text-14 mb-5 leading-5 ",
    heading: "text-[#4F2170] font-bold text-20  md:text-24 md:leading-8",
    containerTitle: "uppercase absolute min-w-[122px] p-10 text-14 font-bold text-white bg-[#957AA9] leading-5 text-center"
}

export const SECTION_9_3_PART_TABCONTAINER = { //NOTE :SPECIALLY this variant is used for /makers-bakers-bulletin-board page
    tabContainerMainWrapper: "tabContainerMainWrapper flex max-lg:flex-wrap lg:items-start mx-auto lg:max-w-lg xl:max-w-xl",
    tabContainerWrapperTabs: "tabContainerWrapperTabs",
    tabContainerWrapperLinks: "tabContainerWrapperLinks",
    galleryContainerWrapper: "galleryContainerWrapper flex flex-wrap rounded-[6px] max-w-full relative my-40",
    galleryContainer: "tabContainerLeftSection w-full lg:w-3/4 lg:max-w-[972px] py-50 mx-15 md:mx-30 lg:mr-0 lg:ml-0 px-15",
    galleryHeading: "text-[24px] lg:text-[48px] text-green font-Light my-[45px] leading-[1.2] tracking-normal mt-0 w-full text-left",
    filterTabs: "flex flex-wrap mb-15 text-[#724D8D]",
    filterTab:"filterTabItems cursor-pointer decoration-none text-[#333333] w-[150px] md:w-[157px] mb-8 bg-[#f2f2f2] text-center p-15 border-box select-none text-16 leading-[24px] font-bold",
    activeTab:"activeTab bg-white text-black",
    panels:"panels px-25 py-10 w-full",
    imgWrapper:"panelsWrapper flex flex-wrap [&>div]:mb-15 [&>div]:w-full",
    imageBoxWrpr: "mt-25 px-5 w-full md:w-1/3 lg:w-1/4 md:px-15",
    imgContainer: "block",
    imgWrpr: "min-h-[130px] max-h-[130px] h-[100%] w-100% object-cover md:min-h-[280px] md:max-h-[280px] lg:min-h-[275px] lg:max-h-[275px]",
    panelHeading: "text-[17px]",
    contentWrapr: "flex flex-col-reverse",
    text: " text-[#070707] font-bold text-14 mb-5 leading-5 ",
    heading: "text-[#4F2170] font-bold text-20  md:text-24 md:leading-8",
    containerTitle: "uppercase absolute min-w-[122px] p-10 text-14 font-bold text-white bg-[#957AA9] leading-5 text-center"
}

export const TABBING_WITH_LANG = {
    ...SECTION_9_3_PART_TABCONTAINER,
    tabContainerMainWrapper: "tabContainerMainWrapper tabContainerMainWrapperLang flex max-lg:flex-wrap lg:items-start mx-auto lg:max-w-lg xl:max-w-xl",
    galleryContainerWrapper: "flex flex-wrap relative my-40 max-md:px-[15px]",
    tabs: "max-md:w-full",
    imgWrapper: "flex flex-wrap [&>div]:mb-15 [&>div]:w-full",
    galleryContainer: "tabContainerLeftSection md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[15px]",
    filterTab: "cursor-pointer px-[32px] py-[16px] text-black tracking-normal decoration-none mb-8 text-center w-full text-[16px] leading-[24px] font-bold bg-white",
    panels: "panels",
    filterTabs: "md:flex lg:flex block mb-15",
    content: "hidden",
    show: "block"
}
export const TAB_STYLES = {
    ul: "",
    liTab: "w-1/2 p-[1rem] list-none text-center  transition-all",
    nav: "",
    tabs: "flex isolate justify-center w-full min-h-[100px] bg-lightOrange my-0 mx-auto  pt-[2rem] text-black rounded-0 lg:overflow-hidden overflow-x-scroll max-w-[100%]",
    filterTab: "relative tab justify-center  w-[234px] rounded-[0.8rem] my-10  py-10 cursor-pointer flex items-center hover:py-10 hover:my-0 transition-all duration-1000 ",
    panel: "hidden panel min-h-300 p-10 w-full mx-50",
    panelActive: " panelActive min-h-300 p-10 w-full",
    panels: "panels bg-lightOrange ",
    tabHeading: "bg-{#fff} text-center rounded-t-[2rem]",
    h3: "py-40 text-18 text-textOrange tracking-[3px] uppercase",
    galleryHeading: "text-[42px] text-black",
    activeTab: "bg-backgroundActive text-white my-0 py-20 activeMrg active w-[234px]",
    filterTabs: 'flex item-center w-[1170px] justify-between pl-0 bg-white nav w-full rounded-[0.8rem] lg:absolute relative ulNav whitespace-nowrap flex-nowrap mt-20',
    slide: 'slide zMinus absolute left-[0px] w-[234px] h-[100%] bg-darkBlue text-white rounded-[20px] opacity-100',
    imgWrapper: 'grid grid-cols-4  gap-20',
    imageBoxWrpr: "imageBoxWrpr w-2/5 ",
    imgContainer: "imgContainer flex p-15 w-[150px]",
    imgWrpr: " imgWrpr w-[150px] [h-150px]",
    heading: "text-[17px] ",
}

export const Gallery = {
    galleryContainer: "px-[36.5px] mt-20 pt-60",
    galleryHeading: "text-[#070707] text-[28px] text-center font-black mb-20",
    filterTabs: "flex justify-center flex-wrap mb-15 mx-[-25px] text-[#724D8D]",
    filterTab: "uppercase bg-white border border-[#070707] transition ease-in-out duration-300 px-12 py-8 text-16 text-center bold leading-[22px] mx-5 mb-10 md:w-[186px] md:px-15 md:py-13 md:text-20 md:mx-10 md:my-0 hover:cursor-pointer hover:bg-[#724D8D] hover:text-white",
    activeTab: "bg-[#724D8D] text-white",
    panels: "panels",
    imgWrapper: " flex flex-wrap",
    imageBoxWrpr: "mt-25 px-5 w-full md:w-1/3 lg:w-1/4 md:px-15",
    imgContainer: "block",
    imgWrpr: "min-h-[130px] max-h-[130px] h-[100%] w-100% object-cover md:min-h-[280px] md:max-h-[280px] lg:min-h-[275px] lg:max-h-[275px]",
    panelHeading: "text-[17px]",
    contentWrapr: "flex flex-col-reverse",
    text: " text-[#070707] font-bold text-14 mb-5 leading-5 ",
    heading: "text-[#4F2170] font-bold text-20  md:text-24 md:leading-8",
    containerTitle: "uppercase absolute min-w-[122px] p-10 text-14 font-bold text-white bg-[#957AA9] leading-5 text-center"
}



